import bugsnagClient from '@shared/bugsnagClient';

export default bugsnagClient.getPlugin('react');
